/* GrinchRides theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  /* ------------------------------------------------------------------ utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || theme.moneyFormat || '{{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(placeholder);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 3500);
  }

  function lockScroll(lock) { document.body.classList.toggle('is-locked', !!lock); }

  /* -------------------------------------------------------------- countdown */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el._cd) clearInterval(el._cd);
      var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
      var end = new Date(raw);
      if (!raw || isNaN(end.getTime())) { el.hidden = true; return; }
      var wrap = el.closest('[data-countdown-wrap]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) {
          clearInterval(el._cd);
          el.hidden = true;
          if (wrap && wrap.hasAttribute('data-hide-when-done')) wrap.hidden = true;
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var map = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
        Object.keys(map).forEach(function (k) {
          var n = $('[data-' + k + ']', el);
          if (n) n.textContent = map[k];
        });
        el.hidden = false;
      }
      tick();
      el._cd = setInterval(tick, 1000);
    });
  }

  /* ----------------------------------------------------------------- header */
  function initHeader(root) {
    var header = $('[data-header]', root);
    if (header && header.classList.contains('is-sticky') && !header._bound) {
      header._bound = true;
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var nav = $('[data-mobile-nav]', root);
    if (!nav) return;
    $$('[data-mobile-nav-open]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true'); lockScroll(true);
        var first = $('a, button', nav.querySelector('.mobile-nav__panel'));
        if (first) first.focus();
      });
    });
    function close() {
      nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true'); lockScroll(false);
      $$('[data-mobile-nav-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    $$('[data-mobile-nav-close]', nav).forEach(function (b) { b.addEventListener('click', close); });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) close(); });
  }

  /* ----------------------------------------------------------------- reveal */
  var revealObserver = null;
  function initReveal(root) {
    if (!document.body.classList.contains('has-animations')) return;
    var els = $$('.reveal:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { revealObserver.observe(e); });
  }

  /* -------------------------------------------------------------- accordion */
  function initAccordions(root) {
    $$('[data-accordion-group]', root).forEach(function (group) {
      if (group._bound) return; group._bound = true;
      var items = $$('details', group);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* --------------------------------------------------------------- delivery */
  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      var pmin = +el.getAttribute('data-pmin') || 0, pmax = +el.getAttribute('data-pmax') || 0;
      var smin = +el.getAttribute('data-smin') || 0, smax = +el.getAttribute('data-smax') || 0;
      var skip = el.getAttribute('data-skip-weekends') === 'true';
      var locale = theme.locale || document.documentElement.lang || 'en';
      function addDays(date, n) {
        var d = new Date(date.getTime());
        if (!skip) { d.setDate(d.getDate() + n); return d; }
        var added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); var day = d.getDay(); if (day !== 0 && day !== 6) added++; }
        return d;
      }
      var f;
      try { f = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }); }
      catch (e) { f = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }); }
      var now = new Date();
      function range(a, b) { var x = f.format(a), y = f.format(b); return x === y ? x : x + ' – ' + y; }
      var dates = [
        f.format(now),
        range(addDays(now, pmin), addDays(now, pmax)),
        range(addDays(now, pmin + smin), addDays(now, pmax + smax))
      ];
      $$('[data-delivery-date]', el).forEach(function (n) {
        n.textContent = dates[+n.getAttribute('data-delivery-date')] || '';
      });
    });
  }

  /* ---------------------------------------------------------------- gallery */
  function initGallery(gallery) {
    if (!gallery || gallery._bound) return;
    gallery._bound = true;
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    var counter = $('[data-gallery-counter]', gallery);
    if (!track || !slides.length) return;
    var index = 0;

    function setActive(i) {
      index = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var activeThumb = thumbs[i];
      if (activeThumb && activeThumb.parentElement.scrollWidth > activeThumb.parentElement.clientWidth) {
        activeThumb.parentElement.scrollTo({ left: activeThumb.offsetLeft - 40, behavior: 'smooth' });
      }
      slides.forEach(function (s, n) {
        var v = s.querySelector('video');
        if (v && n !== i && !v.paused) v.pause();
      });
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    gallery.goToMedia = function (mediaId) {
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-media-id') === String(mediaId)) { goTo(n); return; }
      }
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) setActive(i);
      });
    }, { passive: true });
    setActive(0);
  }

  /* ---------------------------------------------------------------- product */
  function ProductSection(el) {
    this.el = el;
    var dataEl = $('[data-product-json]', el);
    if (!dataEl) return;
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    this.form = $('form[data-product-form]', el);
    this.idInput = this.form ? $('input[name="id"]', this.form) : null;
    this.qtyInput = this.form ? $('input[name="quantity"]', this.form) : null;
    this.atc = $('[data-atc]', el);
    this.gallery = $('[data-gallery]', el);
    this.sticky = $('[data-sticky-atc]', el);
    this.variant = this.findVariantById(this.idInput ? this.idInput.value : null) || this.data.variants[0];
    initGallery(this.gallery);
    this.bind();
    this.update(false);
    this.initSticky();
  }

  ProductSection.prototype.findVariantById = function (id) {
    if (!id) return null;
    for (var i = 0; i < this.data.variants.length; i++) if (String(this.data.variants[i].id) === String(id)) return this.data.variants[i];
    return null;
  };

  ProductSection.prototype.selectedOptions = function () {
    var opts = [];
    $$('[data-option-index]', this.el).forEach(function (group) {
      if (group.closest('[data-sticky-atc]')) return;
      var i = +group.getAttribute('data-option-index');
      var checked = $('input:checked', group);
      var select = $('select', group);
      opts[i] = checked ? checked.value : (select ? select.value : null);
    });
    return opts;
  };

  ProductSection.prototype.bind = function () {
    var self = this;
    $$('[data-option-index]', this.el).forEach(function (group) {
      group.addEventListener('change', function () {
        var opts = self.selectedOptions();
        var match = self.data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
        })[0];
        self.variant = match || null;
        self.update(true);
      });
    });
    $$('[data-bundle-input]', this.el).forEach(function (input) {
      input.addEventListener('change', function () { self.update(false); });
    });
    $$('[data-addon]', this.el).forEach(function (cb) {
      cb.addEventListener('change', function () {
        var row = cb.closest('.addon');
        if (row) row.classList.toggle('is-checked', cb.checked);
      });
    });
    if (this.form) {
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
    }
    var stickySelect = this.sticky ? $('[data-sticky-variant]', this.sticky) : null;
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var v = self.findVariantById(stickySelect.value);
        if (!v) return;
        self.variant = v;
        // sync main option inputs
        v.options.forEach(function (val, i) {
          var group = $('[data-option-index="' + i + '"]', self.form ? self.form.closest('[data-product-section]') : self.el);
          if (!group) return;
          var radio = $$('input', group).filter(function (r) { return r.value === val; })[0];
          if (radio) radio.checked = true;
          var sel = $('select', group);
          if (sel) sel.value = val;
        });
        self.update(true);
      });
    }
    var stickyBtn = this.sticky ? $('[data-sticky-submit]', this.sticky) : null;
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (self.variant && self.variant.available) self.addToCart();
        else if (self.form) self.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  };

  ProductSection.prototype.bundle = function () {
    var input = $('[data-bundle-input]:checked', this.el);
    if (!input) return { qty: 1, discount: 0 };
    return { qty: +input.getAttribute('data-qty') || 1, discount: +input.getAttribute('data-discount') || 0 };
  };

  ProductSection.prototype.update = function (fromUser) {
    var v = this.variant;
    var el = this.el;
    var b = this.bundle();
    var available = !!(v && v.available);

    if (v && this.idInput) this.idInput.value = v.id;
    if (this.qtyInput) this.qtyInput.value = b.qty;

    // price block
    if (v) {
      var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
      $$('[data-price-current]', el).forEach(function (n) { n.innerHTML = formatMoney(v.price); });
      $$('[data-price-compare]', el).forEach(function (n) { n.innerHTML = compare ? formatMoney(compare) : ''; n.hidden = !compare; });
      $$('[data-price-save]', el).forEach(function (n) {
        if (!compare) { n.hidden = true; return; }
        var mode = n.getAttribute('data-mode');
        var txt = mode === 'amount' ? formatMoney(compare - v.price) : Math.round((compare - v.price) * 100 / compare) + '%';
        var label = $('[data-save-value]', n);
        if (label) label.innerHTML = txt;
        n.hidden = false;
      });
    }

    // bundles
    if (v) {
      $$('[data-bundle-input]', el).forEach(function (input) {
        var card = input.parentElement;
        var q = +input.getAttribute('data-qty') || 1;
        var d = +input.getAttribute('data-discount') || 0;
        var total = Math.round(v.price * q * (1 - d / 100));
        var base = (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price) * q;
        var priceEl = $('[data-bundle-price]', card);
        var compareEl = $('[data-bundle-compare]', card);
        var saveEl = $('[data-bundle-save]', card);
        if (priceEl) priceEl.innerHTML = formatMoney(total);
        if (compareEl) { compareEl.innerHTML = base > total ? formatMoney(base) : ''; compareEl.hidden = !(base > total); }
        if (saveEl) {
          if (base > total) { var sv = $('[data-save-value]', saveEl); if (sv) sv.innerHTML = formatMoney(base - total); saveEl.hidden = false; }
          else saveEl.hidden = true;
        }
      });
    }

    // add to cart button
    var total = v ? Math.round(v.price * b.qty * (1 - b.discount / 100)) : 0;
    var label = !v ? strings.unavailable : (available ? strings.addToCart : strings.soldOut);
    [this.atc, this.sticky ? $('[data-sticky-submit]', this.sticky) : null].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
      var t = $('[data-atc-text]', btn);
      if (t) t.textContent = label;
      var p = $('[data-atc-price]', btn);
      if (p) { p.innerHTML = available ? formatMoney(total) : ''; p.hidden = !available; }
    });

    // stock badge (real inventory only)
    var badge = $('[data-stock-badge]', el);
    if (badge && v) {
      var threshold = +badge.getAttribute('data-threshold') || 0;
      var low = $('[data-stock-low]', badge), def = $('[data-stock-default]', badge);
      var showLow = v.tracked && v.policy === 'deny' && v.inv > 0 && v.inv <= threshold;
      if (low) {
        low.hidden = !showLow;
        var c = $('[data-stock-count]', low);
        if (c) c.textContent = v.inv;
      }
      if (def) def.hidden = showLow;
      badge.hidden = !showLow && !def;
    }

    // option availability styling
    if (v) {
      var self = this;
      $$('[data-option-index]', el).forEach(function (group) {
        var i = +group.getAttribute('data-option-index');
        $$('input', group).forEach(function (input) {
          var possible = self.data.variants.some(function (x) {
            return x.available && x.options[i] === input.value && x.options.every(function (o, j) { return j === i || o === v.options[j]; });
          });
          input.classList.toggle('is-unavailable', !possible);
        });
        var label = $('[data-option-value]', group);
        if (label) label.textContent = v.options[i];
      });
    }

    // sticky
    if (this.sticky && v) {
      var sp = $('[data-sticky-price]', this.sticky), sc = $('[data-sticky-compare]', this.sticky), ss = $('[data-sticky-variant]', this.sticky);
      if (sp) sp.innerHTML = formatMoney(v.price);
      if (sc) { var cmp = v.compare_at_price > v.price ? v.compare_at_price : 0; sc.innerHTML = cmp ? formatMoney(cmp) : ''; sc.hidden = !cmp; }
      if (ss && ss.value !== String(v.id)) ss.value = v.id;
    }

    this.bundleSizesRender();

    if (fromUser && v) {
      if (v.media_id && this.gallery && this.gallery.goToMedia) this.gallery.goToMedia(v.media_id);
      if (this.el.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  };

  ProductSection.prototype.addToCart = function () {
    var self = this;
    var v = this.variant;
    if (!v || !v.available) return;
    var b = this.bundle();
    var items = this.bundleSizeLines() || [{ id: v.id, quantity: b.qty }];
    $$('[data-addon]:checked', this.el).forEach(function (cb) { items.push({ id: +cb.value, quantity: 1, properties: { _addon: '1' } }); });
    var errorEl = $('[data-form-error]', this.el);
    if (errorEl) errorEl.hidden = true;
    var buttons = [this.atc, this.sticky ? $('[data-sticky-submit]', this.sticky) : null].filter(Boolean);
    buttons.forEach(function (btn) { btn.classList.add('is-loading'); btn.disabled = true; });
    var useDrawer = theme.cartType === 'drawer' && document.querySelector('[data-cart-drawer]');
    var body = { items: items };
    if (useDrawer) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }
    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var msg = res.json.description || res.json.message || strings.cartError;
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else toast(msg);
          return;
        }
        if (useDrawer && res.json.sections) {
          CartDrawer.render(res.json.sections['cart-drawer']);
          CartDrawer.open();
        } else {
          window.location.href = theme.routes.cart;
        }
      })
      .catch(function () { toast(strings.cartError); })
      .finally(function () {
        buttons.forEach(function (btn) { btn.classList.remove('is-loading'); });
        self.update(false);
      });
  };

  ProductSection.prototype.initSticky = function () {
    var sticky = this.sticky, anchor = this.atc || this.form;
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.footer');
    var anchorVisible = true, footerVisible = false, passed = false;
    function apply() { sticky.classList.toggle('is-visible', !anchorVisible && passed && !footerVisible); sticky.setAttribute('aria-hidden', sticky.classList.contains('is-visible') ? 'false' : 'true'); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { anchorVisible = e.isIntersecting; passed = e.boundingClientRect.top < 0; });
      apply();
    }).observe(anchor);
    if (footer) new IntersectionObserver(function (entries) { entries.forEach(function (e) { footerVisible = e.isIntersecting; }); apply(); }).observe(footer);
  };

  /* ------------------------------------------------------------ bundle: size per item */
  // Bundles with 2+ items get one size dropdown per item, so a customer can mix sizes.
  var BUNDLE_SIZE_TEXT = { title: 'Choose a size for each item', item: 'Size' };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  ProductSection.prototype.bundleSizesBuild = function () {
    var self = this;
    if (this.data.variants.length < 2) return;
    var options = this.data.variants.map(function (v) {
      var price = formatMoney(v.price).replace(/<[^>]*>/g, '');
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title) + ' - ' + price + (v.available ? '' : ' (' + strings.soldOut + ')') + '</option>';
    }).join('');
    $$('[data-bundle-input]', this.el).forEach(function (input) {
      var qty = +input.getAttribute('data-qty') || 1;
      if (qty < 2 || input._sizes) return;
      var html = '<p class="bundle-sizes__title">' + BUNDLE_SIZE_TEXT.title + '</p>';
      for (var i = 0; i < qty; i++) {
        html += '<label class="bundle-sizes__row"><span class="bundle-sizes__label">' + BUNDLE_SIZE_TEXT.item + ' ' + (i + 1) + '</span>' +
          '<span class="bundle-sizes__select"><select data-bundle-size>' + options + '</select></span></label>';
      }
      var box = document.createElement('div');
      box.className = 'bundle-sizes';
      box.hidden = true;
      box.innerHTML = html;
      input.parentElement.insertAdjacentElement('afterend', box);
      box.addEventListener('change', function () { self.update(false); });
      input._sizes = box;
    });
  };

  // Variants picked for each item of the selected bundle, or null when it has no size dropdowns.
  ProductSection.prototype.bundleSizeVariants = function () {
    var input = $('[data-bundle-input]:checked', this.el);
    if (!input || !input._sizes) return null;
    var self = this;
    var list = $$('[data-bundle-size]', input._sizes).map(function (s) { return self.findVariantById(s.value); });
    return list.indexOf(null) === -1 ? list : null;
  };

  // Cart lines for the selected bundle, grouped by variant: [{ id, quantity }].
  ProductSection.prototype.bundleSizeLines = function () {
    var list = this.bundleSizeVariants();
    if (!list) return null;
    var lines = [], byId = {};
    list.forEach(function (v) {
      if (!byId[v.id]) { byId[v.id] = { id: v.id, quantity: 0 }; lines.push(byId[v.id]); }
      byId[v.id].quantity++;
    });
    return lines;
  };

  ProductSection.prototype.bundleSizesRender = function () {
    if (!this._sizesBuilt) { this._sizesBuilt = true; this.bundleSizesBuild(); }
    var v = this.variant;
    // The main size picker sets every item; customers can then change single items.
    if (v && this._sizesVariant !== v.id) {
      this._sizesVariant = v.id;
      $$('[data-bundle-size]', this.el).forEach(function (s) { s.value = String(v.id); });
    }
    var checked = $('[data-bundle-input]:checked', this.el);
    $$('[data-bundle-input]', this.el).forEach(function (input) {
      if (input._sizes) input._sizes.hidden = input !== checked;
    });
    var list = this.bundleSizeVariants();
    if (!list) return;
    var b = this.bundle(), sum = 0, base = 0, available = true;
    list.forEach(function (x) {
      sum += x.price;
      base += x.compare_at_price && x.compare_at_price > x.price ? x.compare_at_price : x.price;
      if (!x.available) available = false;
    });
    var total = Math.round(sum * (1 - b.discount / 100));
    var card = checked.parentElement;
    var priceEl = $('[data-bundle-price]', card), compareEl = $('[data-bundle-compare]', card), saveEl = $('[data-bundle-save]', card);
    if (priceEl) priceEl.innerHTML = formatMoney(total);
    if (compareEl) { compareEl.innerHTML = base > total ? formatMoney(base) : ''; compareEl.hidden = !(base > total); }
    if (saveEl) {
      var sv = $('[data-save-value]', saveEl);
      if (sv) sv.innerHTML = formatMoney(base - total);
      saveEl.hidden = !(base > total);
    }
    var label = available ? strings.addToCart : strings.soldOut;
    [this.atc, this.sticky ? $('[data-sticky-submit]', this.sticky) : null].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
      var t = $('[data-atc-text]', btn);
      if (t) t.textContent = label;
      var p = $('[data-atc-price]', btn);
      if (p) { p.innerHTML = available ? formatMoney(total) : ''; p.hidden = !available; }
    });
  };

  function initProducts(root) {
    $$('[data-product-section]', root).forEach(function (el) {
      if (el._product) return;
      el._product = new ProductSection(el);
    });
  }

  /* ------------------------------------------------------------ cart drawer */
  var CartDrawer = {
    el: function () { return document.querySelector('[data-cart-drawer]'); },
    open: function () {
      var d = this.el(); if (!d) return false;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lockScroll(true);
      var c = $('[data-cart-close]', d); if (c) setTimeout(function () { c.focus(); }, 50);
      return true;
    },
    close: function () {
      var d = this.el(); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lockScroll(false);
    },
    render: function (html) {
      var d = this.el(); if (!d || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]', d);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      var count = fresh ? fresh.getAttribute('data-count') : null;
      if (count !== null) updateCount(count);
      initDelivery(d);
    },
    // Upsells (add-ons) are tied to the main product: once no main product is left in the cart, they are removed too.
    isAddon: function (item) {
      if (item.properties && item.properties._addon) return true;
      return !item.requires_shipping && !item.gift_card;
    },
    orphanAddons: function (cart) {
      var self = this;
      var items = (cart && cart.items) || [];
      if (items.some(function (i) { return !self.isAddon(i); })) return [];
      return items.filter(function (i) { return self.isAddon(i); });
    },
    cleanup: function (cart, withSections) {
      var orphans = this.orphanAddons(cart);
      if (!orphans.length) return Promise.resolve(null);
      var updates = {};
      orphans.forEach(function (i) { updates[i.key] = 0; });
      var body = { updates: updates };
      if (withSections) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }
      return fetch(theme.routes.cart + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },
    sync: function () {
      var self = this;
      var count = document.querySelector('[data-cart-count]');
      if (count && count.textContent.trim() === '0') return;
      fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return self.cleanup(cart, !!self.el()); })
        .then(function (res) {
          if (!res || res.status) return;
          if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
          if (res.sections && res.sections['cart-drawer']) self.render(res.sections['cart-drawer']);
          else updateCount(res.item_count);
        })
        .catch(function () {});
    },
    change: function (key, qty) {
      var d = this.el(); if (!d) return;
      d.classList.add('is-updating');
      var self = this;
      fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.status) { toast(j.description || j.message || strings.cartError); return; }
          return self.cleanup(j, true).then(function (c) { var s = (c && c.sections) || j.sections; if (s) self.render(s['cart-drawer']); });
        })
        .catch(function () { toast(strings.cartError); })
        .finally(function () { d.classList.remove('is-updating'); });
    }
  };
  theme.CartDrawer = CartDrawer;

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (n) { n.textContent = count; });
    $$('.cart-btn').forEach(function (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
  }

  function initCartDrawer() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn && theme.cartType === 'drawer' && CartDrawer.el()) { e.preventDefault(); CartDrawer.open(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); CartDrawer.close(); return; }
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn && qtyBtn.closest('[data-cart-drawer]')) {
        e.preventDefault();
        var line = qtyBtn.closest('[data-line-key]');
        var input = $('input', line);
        var next = Math.max(0, (+input.value || 0) + (+qtyBtn.getAttribute('data-qty-change')));
        CartDrawer.change(line.getAttribute('data-line-key'), next);
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm && rm.closest('[data-cart-drawer]')) {
        e.preventDefault();
        CartDrawer.change(rm.closest('[data-line-key]').getAttribute('data-line-key'), 0);
      }
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-key] input[type="number"]');
      if (input && input.closest('[data-cart-drawer]')) {
        CartDrawer.change(input.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, +input.value || 0));
      }
      var note = e.target.closest('[data-cart-note]');
      if (note) {
        fetch(theme.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      }
      // cart page: auto-submit quantity changes
      var pageQty = e.target.closest('[data-cart-page] input[type="number"]');
      if (pageQty && pageQty.form) pageQty.form.submit();
    });
    document.addEventListener('keydown', function (e) {
      var d = CartDrawer.el();
      if (e.key === 'Escape' && d && d.classList.contains('is-open')) CartDrawer.close();
    });
    // cart page +/- buttons
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-page] [data-qty-change]');
      if (!b) return;
      e.preventDefault();
      var input = $('input', b.closest('.qty'));
      input.value = Math.max(0, (+input.value || 0) + (+b.getAttribute('data-qty-change')));
      input.form.submit();
    });
  }

  /* -------------------------------------------------------------- scroll-to */
  function initScrollLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-scroll-to-product]');
      if (!a) return;
      var target = document.querySelector('[data-product-section]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ------------------------------------------------------------------- init */
  function init(root) {
    root = root || document;
    initCountdowns(root);
    initHeader(root);
    initReveal(root);
    initAccordions(root);
    initDelivery(root);
    initProducts(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initCartDrawer();
    initScrollLinks();
    CartDrawer.sync();
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest('details');
    if (d) d.open = true;
  });
})();
